// Forudsaetning: Klaviyos onsite-tracking-script er allerede installeret
// pa sitet (det er det normalt automatisk via jeres Shopify-Klaviyo-
// integration). Denne fil bruger det til at sende et "Fortrydelse
// anmodet"-event, som I trigger en Klaviyo Flow paa for at sende
// bekraeftelsen til kunden. HUSK at markere flow-beskeden som
// transaktionel i Klaviyo, sa den sendes uanset markedsforings-samtykke.

(function () {
  "use strict";

  var root = document.getElementById("withdrawal-page");
  if (!root) return;

  var openBtn = document.getElementById("withdrawal-open-btn");
  var overlay = document.getElementById("withdrawal-modal-overlay");
  var closeBtn = document.getElementById("withdrawal-modal-close");
  var form = document.getElementById("withdrawal-contact-form");
  var step1 = document.getElementById("withdrawal-step1");
  var step2 = document.getElementById("withdrawal-step2");
  var successBox = document.getElementById("withdrawal-success");
  var summaryBox = document.getElementById("withdrawal-summary");
  var alertBox = document.getElementById("withdrawal-alert");
  var toStep2Btn = document.getElementById("withdrawal-to-step2");
  var backBtn = document.getElementById("withdrawal-back-btn");
  var bodyField = document.getElementById("withdrawal-body");

  function openModal() {
    overlay.hidden = false;
  }
  function closeModal() {
    overlay.hidden = true;
  }

  openBtn.addEventListener("click", openModal);
  closeBtn.addEventListener("click", closeModal);
  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) closeModal();
  });

  function showAlert(msg) {
    alertBox.textContent = msg;
    alertBox.hidden = false;
  }
  function hideAlert() {
    alertBox.hidden = true;
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str == null ? "" : String(str);
    return div.innerHTML;
  }

  function getValues() {
    return {
      name: document.getElementById("withdrawal-name").value.trim(),
      email: document.getElementById("withdrawal-email").value.trim(),
      orderNumber: document.getElementById("withdrawal-order").value.trim(),
      product: document.getElementById("withdrawal-product").value.trim(),
      reason: document.getElementById("withdrawal-reason").value.trim()
    };
  }

  toStep2Btn.addEventListener("click", function () {
    hideAlert();
    var v = getValues();

    if (!v.name || !v.email || !v.orderNumber || !v.product) {
      showAlert("Udfyld venligst navn, e-mail, ordrenummer og produkt.");
      return;
    }

    summaryBox.innerHTML =
      "<dl>" +
      "<dt>Navn</dt><dd>" + escapeHtml(v.name) + "</dd>" +
      "<dt>E-mail</dt><dd>" + escapeHtml(v.email) + "</dd>" +
      "<dt>Ordrenummer</dt><dd>" + escapeHtml(v.orderNumber) + "</dd>" +
      "<dt>Produkt(er)</dt><dd>" + escapeHtml(v.product) + "</dd>" +
      "<dt>Beskrivelse</dt><dd>" + escapeHtml(v.reason || "(ikke angivet)") + "</dd>" +
      "</dl>";

    bodyField.value =
      "FORTRYDELSESANMODNING\n\n" +
      "Navn: " + v.name + "\n" +
      "E-mail: " + v.email + "\n" +
      "Ordrenummer: " + v.orderNumber + "\n" +
      "Produkt(er): " + v.product + "\n" +
      "Beskrivelse: " + (v.reason || "(ikke angivet)");

    step1.hidden = true;
    step2.hidden = false;
  });

  backBtn.addEventListener("click", function () {
    hideAlert();
    step2.hidden = true;
    step1.hidden = false;
  });

  function sendKlaviyoEvent(v) {
    var _learnq = window._learnq || [];
    window._learnq = _learnq;

    _learnq.push(["identify", { "$email": v.email, "$first_name": v.name }]);
    _learnq.push(["track", "Fortrydelse anmodet", {
      "OrderNumber": v.orderNumber,
      "Product": v.product,
      "Reason": v.reason || "(ikke angivet)",
      "CustomerName": v.name
    }]);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();
    hideAlert();

    var checkbox = document.getElementById("withdrawal-confirm-checkbox");
    if (!checkbox.checked) {
      showAlert("Bekraeft venligst, at du onsker at fortryde ordren.");
      return;
    }

    var submitBtn = document.getElementById("withdrawal-submit-btn");
    var label = submitBtn.querySelector(".btn-label");
    var spinner = submitBtn.querySelector(".btn-spinner");
    submitBtn.disabled = true;
    if (label) label.hidden = true;
    if (spinner) spinner.hidden = false;

    var v = getValues();

    // 1) Send eventet til Klaviyo -> trigger jeres Flow, som sender
    //    bekraeftelsen til kunden.
    sendKlaviyoEvent(v);

    // 2) Send til Shopifys native kontaktformular -> I modtager mailen.
    var formData = new FormData(form);
    fetch(form.action || window.location.pathname, {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" }
    })
      .then(function () {
        step2.hidden = true;
        successBox.hidden = false;
      })
      .catch(function () {
        showAlert("Der opstod en fejl. Prov igen, eller kontakt os direkte.");
      })
      .finally(function () {
        submitBtn.disabled = false;
        if (label) label.hidden = false;
        if (spinner) spinner.hidden = true;
      });
  });
})();
